import { TextField, Typography } from "@mui/material";
import { FieldError } from "react-hook-form";

type Props = {
  value: string;
  onChange: Function;
  fieldError?: FieldError | undefined;
  getValues?: Function;
  disabled?: boolean;
  rows?: { minRows: number; maxRows: number };
  onBlur?: () => void;
};

export const CommentsField = ({
  value,
  onChange,
  fieldError,
  getValues = () => {},
  disabled = false,
  rows = { minRows: 3, maxRows: 3 },
  onBlur = () => {},
}: Props) => {
  return (
    <>
      <TextField
        label="Comments"
        variant="outlined"
        size="small"
        fullWidth
        value={value ?? ""}
        maxRows={rows.maxRows}
        minRows={rows.minRows}
        multiline
        autoComplete="off"
        disabled={disabled}
        onChange={(event) => {
          if (event.target.value.length <= 200) {
            onChange(event.target.value);
          }
        }}
        error={!!fieldError}
        helperText={fieldError?.message}
        onBlur={onBlur}
      />
      {(getValues("Comments")?.length as number) !== 200 && (
        <Typography
          component="span"
          sx={{
            fontSize: 12,
            color: "#757575",
            marginLeft: "5px",
          }}
        >
          {`${getValues("Comments")?.length ?? 0}/200 max.`}
        </Typography>
      )}
      {(getValues("Comments")?.length as number) == 200 && (
        <Typography
          component="span"
          sx={{
            fontSize: 12,
            color: "#757575",
            marginLeft: "5px",
          }}
        >
          Max. 200
        </Typography>
      )}
    </>
  );
};
